<div class="overlay"><Spinner class="loader" size="100px" color="white"></Spinner></div>